<template>
<div class="container-fluid public-view" style="height: 100%;">
    <div class="row" style="height: 100%;">
        <div class="public-side" v-bind:style="{ backgroundSize: 'cover', backgroundImage: `url('${backImg}')` }">
            <div class="public-logo">
                <img src="../assets/infinite-logo-white.svg" />
            </div>
        </div>
        <div class="public-main">
            <div id="main-tabs" class="scroll-y">
                <div v-show="showLoginButton">
                    <div :id="id"></div><br/>
                </div>
                <div class="errortext" v-if="error">{{error}}</div>
                <div class="errortext" v-if="!validLocation"> We're sorry, it appears that our website currently doesn't support your region. If you believe this is an error, please contact our customer support team for more information.</div>
                <div v-if="users.length > 1">
                    <div v-if="showFilters" class="row form-group">
                        <div class="col-12">
                            <h1 class="public-header">Account Selection</h1>
                        </div>
                        <div class="col-6 form-group">
                            <label>Users:</label>
                            <select class="form-control input-sm" v-model="filters.email">
                                <option :value="null">Show All</option>
                                <option v-for="(user, index) in filters.recentUsers" :key="index" :value="user">{{ user }}</option>
                            </select>
                        </div>
                        <div class="col-6 form-group">
                            <label>Roles:</label>
                            <select class="form-control input-sm" v-model="filters.role">
                                <option :value="null">Show All</option>
                                <option v-for="(role, index) in filters.roles" :key="index" :value="role">{{ role }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-12">
                            <label>Accounts (select one to continue):</label>
                            <ul style="list-style-type: none; padding-left: 0;">
                                <li v-for="user in filteredUsers" :key="user.userId">
                                    <a href="#" @click="pickAccount(user)" class="list-group-item list-group-item-action">
                                        <div class="d-flex w-100 justify-content-between">
                                            <h5 class="mb-1">{{ user.username }}</h5>
                                        </div>
                                        <p class="mb-1">Roles: {{ user.roles ? user.roles.split(',').join(', ') : '' }}</p>
                                        <small>Email: {{ user.email }}</small>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { config } from '../config'
import Axios from 'axios';
import sideBackPic from '../assets/background-forest-blue.jpg'
import GoogleAuth from './GoogleAuth'
import { amfDebug } from './utils/amf-debug'
import auth from '../auth'
import loginMixin from './login-mixin';

let componentId = 0;
var vm = {
    mixins: [loginMixin],
    beforeCreate() {
        this.id = `gsuite-button-${componentId}`;
    },
    mounted() {
        var callback = (cred) => {
            this.handleCredentialResponse(cred);
        }

        GoogleAuth.createOneTapScript(callback, this.id).then(result => {
            if(result == 'show_login_button') {
                this.showLoginButton = true;
            }
        });
    },
    destroyed() {
        var el = document.getElementById('google-one-tap');
        if(el) {
            el.parentNode.removeChild(el);
        }
    },
    watch: {
        filters: {
            deep: true,
            handler: function(filter) {
                if(filter.email) {
                    this.filteredUsers = this.users.filter(u => {
                        return u.email.toLowerCase() == filter.email.toLowerCase();
                    });
                }
                else if(filter.role) {
                    this.filteredUsers = this.users.filter(u => {
                        var roles = u.roles == null ? [] : u.roles.split(',');
                        return roles.includes(filter.role);
                    });
                }
                else {
                    this.filteredUsers = [...this.users];
                }
            }
        }
    },
    data() {
        return {
            showLoginButton: false,
            gAuth: null,
            users: [],
            filters: {
                roles: [],
                recentUsers: [],
                role: null,
                email: null
            },
            filteredUsers: [],
            backImg: sideBackPic,
            validLocation: true
        }
    },
    computed: {
        ...amfx.map('session', 'error,apiToken'),
        showFilters() {
            return this.users.length > 5;
        }
    },
    methods: {
        async pickAccount(account) {
            var token = JSON.parse(localStorage.getItem('google-token')).token;
            GoogleAuth.setGsuiteUser();
            var externalSite = !!this.$route.query.redirect;
            var result = await auth.google(token, account.username, externalSite);

            let error = result.error;
            if(error == 'invalid_geo_location')
            {
                this.validLocation = false;
                return;
            }

            if(externalSite) {
                window.location.href = `${this.$route.query.redirect}?token=${result.access_token}`;
            }
            else {
                await this.goToRecent();
            }
        },
        async handleCredentialResponse(response) {
            GoogleAuth.saveGoogleTokenForTenMinutes(response);
            let axios = Axios.create();
            let result = await axios.post(`${config.romeApi}/auth/one-tap`, response);
            this.users = [...result.data];
            this.filteredUsers = [...result.data];

            if(this.users && this.users.length == 1) {
                this.pickAccount(this.users[0]);
            }

            var buildFilters = () => {
                var roles = [];

                for(var user of result.data) {
                    var ur = user.roles.split(',');
                    roles = roles.concat(user.roles.split(','));
                }

                this.filters.roles = [...new Set(roles)];
                var ignore = ['adminfeeinvoicing', 'employer', 'planadmin', 'broker', 'invoicedetails', 'invoicetotals', 'cobracontact', 'monthlyreporting'];
                this.filters.roles = this.filters.roles.filter(r => !ignore.includes(r));

                var me = result.data.find(u => u.exactMatch);
                var validUsers = result.data.map(u => u.email);

                if (me) {
                  this.filters.recentUsers = [me.email].concat(amfDebug.login.suggestedUsers);
                  this.filters.recentUsers = this.filters.recentUsers.filter(u => validUsers.includes(u));
                }
            }

            buildFilters();
        }
    }
}

export default vm;
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/framework/Identity.vue